<template>
    <el-dialog custom-class="data-config-dialog" title="信息采集表单" :visible.sync="dialogVisible" top="70px" :close-on-click-modal="false" width="1000px" @close="closeDialog">
        <j-page class="data-config-layout">
            <el-tabs slot="table" v-model="activeName" type="card">
                <el-tab-pane label="字段配置" name="1">
                    <field-config v-if="activeName == 1" :meta="meta" />
                </el-tab-pane>
                <el-tab-pane label="采集配置" name="2">
                    <collect-config v-if="activeName == 2" :meta="meta" />
                </el-tab-pane>
                <el-tab-pane label="列表展示" name="3">
                    <list-config v-if="activeName == 3" :meta="meta" />
                </el-tab-pane>
                <el-tab-pane label="查询条件" name="4">
                    <query-config v-if="activeName == 4" :meta="meta" />
                </el-tab-pane>
            </el-tabs>
        </j-page>
    </el-dialog>
</template>

<script>
    import PageMixins from "../../../components/JComponents/JPage/mixins/PageMixins";
    import fieldConfig from "./tabs/fieldConfig";
    import collectConfig from "./tabs/collectConfig";
    import listConfig from "./tabs/listConfig";
    import queryConfig from "./tabs/queryConfig";
    export default {
        name: "DataConfig",
        mixins: [PageMixins],
        props: {
          meta: Object
        },
        components: {
            fieldConfig,
            collectConfig,
            listConfig,
            queryConfig
        },
        data() {
            return {
                dialogVisible: true,
                activeName: '1'
            }
        },
        methods: {
            closeDialog() {
                this.$emit('update:close', false)
            }
        }
    }
</script>

<style lang="scss">
    .data-config-dialog {
        .data-config-layout {
            height: 700px;
            .el-tabs__content {
                height: calc(100% - 56px);
                .el-tab-pane {
                    height: 100%;
                }
            }
            .j-page-layout_wrap {
                padding: 0;
            }
        }
    }
</style>
